import { Reveal } from "../components/Reveal";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative scroll-mt-24 bg-ivory px-6 py-28 sm:px-10 sm:py-40"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-20">
        {/* Text column */}
        <div className="lg:col-span-6 lg:pr-10">
          <Reveal>
            <span className="text-[0.7rem] uppercase tracking-[0.28em] text-gold">
              001 — For The Love Of Cooking Art
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-8 font-serif text-5xl font-light leading-[0.95] tracking-tight text-ink sm:text-6xl lg:text-7xl">
              For The Love
              <br />
              Of <span className="italic">Cooking Art</span>
            </h2>
          </Reveal>

          <div className="mt-10 max-w-xl space-y-7 text-base leading-relaxed text-ink-soft">
            <Reveal delay={0.1}>
              <p>
                I'm a creative director, stylist and storyteller based in India.
                Through <span className="text-ink">We Cook Art</span>, I develop visual narratives,
                conceptual shoots and collaborative creative experiments that sit somewhere between
                fashion, cinema and contemporary art.
              </p>
            </Reveal>
            <Reveal delay={0.16}>
              <p>
                My work is driven by emotion, memory, culture, femininity and the belief that images
                can hold stories long after words disappear.
              </p>
            </Reveal>
            <Reveal delay={0.22}>
              <p className="font-serif text-2xl italic leading-snug text-ink">
                “I am less interested in pictures than in the feeling left behind once you look away.”
              </p>
            </Reveal>
          </div>
        </div>

        {/* Image column */}
        <div className="lg:col-span-6">
          <Reveal y={40} className="relative">
            <div className="overflow-hidden">
              <img
                src="/images/saree-01.jpg"
                alt="Pavitra Mishra — A Love Letter To Sarees"
                className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out hover:scale-[1.03]"
              />
            </div>
            <p className="mt-4 text-[0.7rem] uppercase tracking-[0.22em] text-ink-soft">
              Selected frame — A Love Letter To Sarees, Ahmedabad
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
